import { applyToAllStates } from '../../../theme/utils/button.theme.utils';
export var floatingButtonTheme = {
  baseStyle: {
    transitionProperty: 'common',
    transitionDuration: 'normal',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    outline: '2px solid transparent',
    borderRadius: 'l',
    height: '48px',
    width: '48px',
    padding: 's',
    backgroundColor: 'brand.main',
    color: 'neutral.white',
    position: 'absolute',
    bottom: 's',
    right: 's',
    _active: {
      backgroundColor: 'brand.dark'
    },
    _disabled: applyToAllStates({
      cursor: 'not-allowed',
      backgroundColor: 'neutral.lighter',
      color: 'neutral.dark'
    }),
    _focusVisible: {
      outlineColor: 'focus.focus',
      outlineOffset: '2px',
      transition: 'outline-color 0.2s'
    }
  }
};
//# sourceMappingURL=FloatingButton.theme.js.map